import React, { createContext, useContext, useState, useCallback } from 'react';
import translations from './translations';

const LanguageContext = createContext(null);

/**
 * Wrap your app with <LanguageProvider> to get language switching across all components.
 */
export function LanguageProvider({ children }) {
  const [lang, setLang] = useState('en');

  const toggleLang = useCallback(() => {
    setLang(prev => (prev === 'en' ? 'es' : 'en'));
  }, []);

  /**
   * t('hero.overline')  → looks up translations[lang].hero.overline
   * Also accepts an array index for list items:
   *   t('problem.cards', 0, 'title')
   */
  const t = useCallback(
    (keyPath, index, subKey) => {
      const keys = keyPath.split('.');
      let value = translations[lang];
      for (const k of keys) {
        if (value == null) return keyPath;
        value = value[k];
      }
      if (index !== undefined) {
        value = value?.[index];
        if (subKey !== undefined) value = value?.[subKey];
      }
      return value ?? keyPath;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

/** Hook: const { lang, toggleLang, t } = useLanguage(); */
export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used inside <LanguageProvider>');
  return ctx;
}
